export default "__VITE_ASSET__BUP4DwPr__"